import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { detectDevice, redirectToStore } from '../utils/deviceDetection'
import '../styles/DeepLink.css'

function DeepLink() {
  const location = useLocation()

  useEffect(() => {
    const path = location.pathname.replace('/link/', '')
    const device = detectDevice()
    
    // Construct deep link URL
    const deepLink = `breakout://${path}${location.search}`
    
    // Try to open the app
    window.location.href = deepLink
    
    // Fallback to app store after a delay
    const timer = setTimeout(() => {
      redirectToStore(device)
    }, 2000)

    return () => clearTimeout(timer)
  }, [location])

  return (
    <div className="deeplink-page">
      <div className="deeplink-container">
        <div className="loader"></div>
        <h2>Opening Breakout...</h2>
        <p>If the app doesn't open automatically, you'll be redirected to download it.</p>
        <button 
          className="manual-redirect-btn"
          onClick={() => redirectToStore(detectDevice())}
        >
          Go to App Store
        </button>
      </div>
    </div>
  )
}

export default DeepLink
